"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgDepartmentSelector = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_select_1 = require("../../components/input/input.select");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var i18n_1 = require("../../i18n");
var org_department_selector_ctrl_1 = require("./org.department.selector.ctrl");
var OrgDepartmentSelector = /** @class */ (function (_super) {
    tslib_1.__extends(OrgDepartmentSelector, _super);
    function OrgDepartmentSelector(selectorOptions) {
        if (selectorOptions === void 0) { selectorOptions = { crossOrganization: false }; }
        var _this = _super.call(this) || this;
        _this.ctrl = new org_department_selector_ctrl_1.OrgDepartmentSelectorCtrl(selectorOptions.crossOrganization);
        _this.inputState = new input_select_1.SelectInputState(i18n_1.T.DEPARTMENT);
        _this.inputState.isRequired = true;
        _this.reaction(function () { return _this.ctrl.departmentOptions; }, function (options) {
            _this.inputState.setOptions(options);
            if (options.length > 0 && _this.inputState.value == null) {
                _this.inputState.setValue(options[0].value);
            }
        }, { fireImmediately: true });
        _this.reaction(function () { return _this.inputState.value; }, function (departmentId) { return _this.ctrl.selectDepartment(departmentId); }, { fireImmediately: true });
        return _this;
    }
    Object.defineProperty(OrgDepartmentSelector.prototype, "nodes", {
        get: function () {
            if (this.inputState == null) {
                return null;
            }
            if (this.ctrl.loadingDepartments) {
                return spinner_1.Spinner.view();
            }
            return input_select_1.SelectInputComponent.view(this.inputState);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrgDepartmentSelector.prototype, "selectedDepartmentId", {
        get: function () {
            return this.ctrl.selectedDepartmentId;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], OrgDepartmentSelector.prototype, "selectedDepartmentId", null);
    return OrgDepartmentSelector;
}(mithril_component_1.IMithrilStateComponent));
exports.OrgDepartmentSelector = OrgDepartmentSelector;
//# sourceMappingURL=org.department.selector.js.map